<template>
<div class="champion-wrap">
    <h2 class="champion-label">トライアル全日本チャンピオン</h2>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('70')"><span class="history__head--circle">1973-1980</span></button>
        <div class="champions">  
            <section class="champions__sec">
                <h2 class="year-title">1973年<span class="year-title__sub">昭和48年</span></h2>
                <ul>
                    <li>木村治男／<span class="text_chart">選抜</span></li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1974年<span class="year-title__sub">昭和49年</span></h2>
                <ul>
                    <li>伊吹健次／ノービス</li>
                    <li>近藤博志／ジュニア</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1975年<span class="year-title__sub">昭和50年</span></h2>
                <ul>
                    <li>蜂巣秀男／ジュニア</li>
                    <li>加藤文博／エキスパート</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1976年<span class="year-title__sub">昭和51年</span></h2>
                <ul>
                    <li>町田晴男／ジュニア</li>
                    <li>黒山一郎／エキスパート</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1977年<span class="year-title__sub">昭和52年</span></h2>
                <ul>
                    <li>山本昌也／ジュニア</li>
                    <li>近藤博志／エキスパート</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1978年<span class="year-title__sub">昭和53年</span></h2>
                <ul>
                    <li>山田民雄／ジュニア</li>
                    <li>近藤博志／エキスパート</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1979年<span class="year-title__sub">昭和54年</span></h2>
                <ul>
                    <li>佐藤雄一／ジュニア</li>
                    <li>近藤博志／<span class="text_chart">国際A級</span></li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1980年<span class="year-title__sub">昭和55年</span></h2>
                <ul>
                    <li>広木一美／ジュニア</li>
                    <li>丸山胤保／国際A級</li>
                </ul>
            </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('80')"><span class="history__head--circle">1981-1990</span></button>
        <div class="champions">  
            <section class="champions__sec">
                <h2 class="year-title">1981年<span class="year-title__sub">昭和56年</span></h2>
                <ul>
                    <li>石原正美／ノービス</li>
                    <li>黒山一郎／国際A級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1982年<span class="year-title__sub">昭和57年</span></h2>
                <ul>
                    <li>高田雅孝／国際B級</li>
                    <li>山本昌也／国際A級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1983年<span class="year-title__sub">昭和58年</span></h2>
                <ul>
                    <li>和田弘行／国際B級</li>
                    <li>山本昌也／国際A級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1984年<span class="year-title__sub">昭和59年</span></h2>
                <ul>
                    <li>米沢満夫／国際B級</li>
                    <li>山本昌也／国際A級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1985年<span class="year-title__sub">昭和60年</span></h2>
                <ul>
                    <li>泉 裕朗／国際B級</li>
                    <li>山本昌也／国際A級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1986年<span class="year-title__sub">昭和61年</span></h2>
                <ul>
                    <li>小林直樹／国際B級</li>
                    <li>山本昌也／国際A級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1987年<span class="year-title__sub">昭和62年</span></h2>
                <ul>
                    <li>小谷 徹／国際B級</li>
                    <li>伊藤敦志／国際A級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1988年<span class="year-title__sub">昭和63年</span></h2>
                <ul>
                    <li>成田 匠／国際B級</li>
                    <li>伊藤敦志／国際A級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1989年<span class="year-title__sub">昭和64年/平成元年</span></h2>
                <ul>
                    <li>宮道昌浩／国際B級</li>
                    <li>成田 匠／国際A級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1990年<span class="year-title__sub">平成2年</span></h2>
                <ul>
                    <li>前野 繁／国際B級</li>
                    <li>伊藤敦志／国際A級</li>
                </ul>
            </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('90')"><span class="history__head--circle">1991-2000</span></button>
        <div class="champions">  
            <section class="champions__sec">
                <h2 class="year-title">1991年<span class="year-title__sub">平成3年</span></h2>
                <ul>
                    <li>本多元治／国際B級</li>
                    <li>中川義博／国際A級</li>
                    <li>中川義博／国際A級(スタジアムトライアル)</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1992年<span class="year-title__sub">平成4年</span></h2>
                <ul>
                    <li>小川友幸／国際B級</li>
                    <li>パスカル・クトゥリエ／国際A級</li>
                    <li>パスカル・クトゥリエ／国際A級(スタジアムトライアル)</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1993年<span class="year-title__sub">平成5年</span></h2>
                <ul>
                    <li>田中義弘／国際B級</li>
                    <li>パスカル・クトゥリエ／国際A級</li>
                    <li>パスカル・クトゥリエ／国際A級(スタジアムトライアル)</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1994年<span class="year-title__sub">平成6年</span></h2>
                <ul>
                    <li>寺澤慎也／国際B級</li>
                    <li>成田 匠／国際A級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1995年<span class="year-title__sub">平成7年</span></h2>
                <ul>
                    <li>成田 亮／国際B級</li>
                    <li>藤波貴久／国際A級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1996年<span class="year-title__sub">平成8年</span></h2>
                <ul>
                    <li>田中太一／国際B級</li>
                    <li>黒山健一／国際A級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1997年<span class="year-title__sub">平成9年</span></h2>
                <ul>
                    <li>渋谷 勲／国際B級</li>
                    <li>東谷 洋／国際A級</li>
                    <li>黒山健一／国際A級スーパークラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1998年<span class="year-title__sub">平成10年</span></h2>
                <ul>
                    <li>北山将司／国際B級</li>
                    <li>野崎史高／国際A級</li>
                    <li>藤波貴久／国際A級スーパークラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1999年<span class="year-title__sub">平成11年</span></h2>
                <ul>
                    <li>小森文彦／国際B級</li>
                    <li>白神孝之／国際A級</li>
                    <li>藤波貴久／国際A級スーパークラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2000年<span class="year-title__sub">平成12年</span></h2>
                <ul>
                    <li>尾西和博／国際B級</li>
                    <li>田中裕人／国際A級</li>
                    <li>藤波貴久／国際A級スーパークラス</li>
                </ul>
            </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('100')"><span class="history__head--circle">2001-2010</span></button>
        <div class="champions">  
            <section class="champions__sec">
                <h2 class="year-title">2001年<span class="year-title__sub">平成13年</span></h2>
                <ul>
                    <li>安藤剛史／国際B級</li>
                    <li>本多元治／国際A級</li>
                    <li>藤波貴久 ／国際A級スーパークラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2002年<span class="year-title__sub">平成14年</span></h2>
                <ul>
                    <li>徳丸貴幸／国際B級</li>
                    <li>田中裕人／国際A級</li>
                    <li>黒山健一／国際A級スーパークラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2003年<span class="year-title__sub">平成15年</span></h2>
                <ul>
                    <li>藤原由樹／国際B級</li>
                    <li>田中裕人／国際A級</li>
                    <li>黒山健一／国際A級スーパークラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2004年<span class="year-title__sub">平成16年</span></h2>
                <ul>
                    <li>川村義仁／国際B級</li>
                    <li>田中善弘／国際A級</li>
                    <li>黒山健一／国際A級スーパークラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2005年<span class="year-title__sub">平成17年</span></h2>
                <ul>
                    <li>辻真太郎／国際B級</li>
                    <li>坂田匠太／国際A級</li>
                    <li>黒山健一／国際A級スーパークラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2006年<span class="year-title__sub">平成18年</span></h2>
                <ul>
                    <li>平田雅裕／国際B級</li>
                    <li>小森文彦／国際A級</li>
                    <li>黒山健一／国際A級スーパークラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2007年<span class="year-title__sub">平成19年</span></h2>
                <ul>
                    <li>平田貴裕／国際B級</li>
                    <li>成田 匠／国際A級</li>
                    <li>小川友幸／国際A級スーパークラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2008年<span class="year-title__sub">平成20年</span></h2>
                <ul>
                    <li>小野田理智／国際B級</li>
                    <li>西元良太／国際A級</li>
                    <li>黒山健一／国際A級スーパークラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2009年<span class="year-title__sub">平成21年</span></h2>
                <ul>
                    <li>山本直樹／国際B級</li>
                    <li>藤巻耕太／国際A級</li>
                    <li>黒山健一／国際A級スーパークラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2010年<span class="year-title__sub">平成22年</span></h2>
                <ul>
                    <li>宮本竜馬／国際B級</li>
                    <li>田中裕人／国際A級</li>
                    <li>小川友幸 ／国際A級スーパークラス</li>
                </ul>
            </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('110')"><span class="history__head--circle">2011-2020</span></button>
        <div class="champions">  
            <section class="champions__sec">
                <h2 class="year-title">2011年<span class="year-title__sub">平成23年</span></h2>
                <ul>
                    <li>小谷一貴／国際B級</li>
                    <li>三谷英明／国際A級</li>
                    <li>黒山健一／国際A級スーパークラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2012年<span class="year-title__sub">平成24年</span></h2>
                <ul>
                    <li>武井誠也／国際B級</li>
                    <li>加賀国光／国際A級</li>
                    <li>黒山健一／国際A級スーパークラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2013年<span class="year-title__sub">平成25年</span></h2>
                <ul>
                    <li>倉持俊輝／国際B級</li>
                    <li>成田 亮／国際A級</li>
                    <li>小川友幸／国際A級スーパークラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2014年<span class="year-title__sub">平成26年</span></h2>
                <ul>
                    <li>氏川湧雅／国際B級</li>
                    <li>藤原慎也／国際A級</li>
                    <li>小川友幸／国際A級スーパークラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2015年<span class="year-title__sub">平成27年</span></h2>
                <ul>
                    <li>山崎頌太／国際B級</li>
                    <li>岡村将敏／国際A級</li>
                    <li>小川友幸／国際A級スーパークラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2016年<span class="year-title__sub">平成28年</span></h2>
                <ul>
                    <li>西村亜弥／レディース</li>
                    <li>氏川政哉／国際B級</li>
                    <li>久岡孝二／国際A級</li>
                    <li>小川友幸／国際A級スーパークラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2017年<span class="year-title__sub">平成29年</span></h2>
                <ul>
                    <li>西村亜弥／レディース</li>
                    <li>山中悟史／国際B級</li>
                    <li>氏川政哉／国際A級</li>
                    <li>小川友幸／国際A級スーパークラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2018年<span class="year-title__sub">平成30年</span></h2>
                <ul>
                    <li>西村亜弥／レディース</li>
                    <li>山森篤志／国際B級</li>
                    <li>武井誠也／国際A級</li>
                    <li>小川友幸／国際A級スーパークラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2019年<span class="year-title__sub">平成31年/令和元年</span></h2>
                <ul>
                    <li>西村亜弥／レディース</li>
                    <li>池田 力／国際B級</li>
                    <li>武田呼人／国際A級</li>
                    <li>小川友幸／国際A級スーパークラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2020年<span class="year-title__sub">令和2年</span></h2>
                <ul>
                    <li>西村亜弥／レディース</li>
                    <li>中山光太／国際B級</li>
                    <li>廣畑伸哉／国際A級</li>
                    <li>小川友幸／国際A級スーパークラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2021年<span class="year-title__sub">令和3年</span></h2>
                <ul>
                    <li>小川 友幸／国際A級スーパー</li>
                    <li>村田 慎示／国際A級</li>
                    <li>浦山 瑞希／国際B級</li>
                    <li>西村 亜弥／レディース</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2022年<span class="year-title__sub">令和4年</span></h2>
                <ul>
                    <li>小川 友幸／国際A級スーパー</li>
                    <li>田中 善弘／国際A級</li>
                    <li>宮崎 航／国際B級</li>
                    <li>山中 玲美／レディース</li>
                </ul>
            </section>
        </div>
    </div>
</div>
</template>

<script>
    import Mixin from '@/mixins/mixin.js'
    export default {
        data: function() {
            return {
                show_contents: ['70']
            }
        },
        mixins: [Mixin],
    }
</script>

<style lang="scss">

</style>